import { AbstractApiModel } from '@ng-cloud/badger-core/models/abstract-api-model';

export class RfidTag extends AbstractApiModel<RfidTag> {
  static readonly UNKNOWN = 'UNKNOWN';

  rfidScanEventId: number;
  epc: string;
  detectionCount: number;
  locationConfidence: number;
  scanZoneImage: any;
  metadata: any;
  gtin: string;
  productName: string;
  serialNumber: string;
  x: number;
  y: number;
  z: number;

  scanZoneId: number;
  scanZoneName: string;
  productId: string;
  localized = false;

  deserialize(json: any): this {
    this.rfidScanEventId = json.rfid_scan_event_id;
    this.epc = json.epc;
    this.detectionCount = json.detection_count;
    this.locationConfidence = json.location_confidence;
    this.scanZoneImage = json.scan_zone_image;
    this.metadata = json.metadata;
    this.gtin = json.gtin;
    this.productName = json.product_name;
    this.serialNumber = json.serial_number ? json.serial_number.toString() : '';
    this.scanZoneId = json.scan_zone_id;
    this.x = json.x;
    this.y = json.y;
    this.z = json.z;

    this.localized = !(this.x == null || this.y == null);

    this.productId = this.gtin !== RfidTag.UNKNOWN ? this.gtin : this.epc;

    return super.deserialize(json);
  }

  protected getRandomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  serialize(): any {
    return Object.assign(super.serialize(), {});
  }
}
